import { callService } from "./tools";

const escribir = (oRegistro) => {
	/*let llamadaSeguro = new callService({
		service: "user.accion",
		secure: true,
		data: {
			"accion": oRegistro
		}
	}).execute().then(sResultado => {
	
	}).catch(error => {
		
	});*/
	
	//console.log(oRegistro);
	//dbRef.push().set(JSON.parse(JSON.stringify(oRegistro)));
};

const reporteadorError = store => next => action => {
	try {
		const prevState = store.getState();
		const returnValue = next(action);
		const nextState = store.getState();
		
		const registro = {
			//prevState: prevState,
			nextState: nextState,
			action: action,
			time: new Date().getTime(),
			userAgent: navigator.userAgent
		};
		
		escribir(registro);
		
		return returnValue;
	} catch (err) {
		console.log({ "accion": action, "error": err, "estado": store.getState() });
	
		throw err; 
	}
};

export default reporteadorError;


// WEBPACK FOOTER //
// ./src/app-error.js